import { useId, type SVGProps } from 'react';
const ParrotLogo = (props: SVGProps<SVGSVGElement>) => {
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, '');
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={116}
      height={38}
      fill="none"
      viewBox="0 0 116 38"
      role="img"
      aria-label="Parrot Analytics"
      focusable="false"
      {...props}
    >
      <path
        fill="light-dark(#323232, #ADADAD)"
        fillRule="evenodd"
        d="M42.473 29.381h-1.056l-2.234 5.247h1.169l.477-1.169h2.202l.477 1.169h1.197zm-.543 1.376.692 1.69h-1.384z"
        clipRule="evenodd"
      />
      <path
        fill="light-dark(#323232, #ADADAD)"
        d="M47.742 29.418H48.8l2.44 3.208v-3.208h1.132v5.21h-.975l-2.523-3.312v3.312H47.74z"
      />
      <path
        fill="light-dark(#323232, #ADADAD)"
        fillRule="evenodd"
        d="M58.697 29.381h-1.058l-2.233 5.247h1.169l.476-1.169h2.203l.476 1.169h1.199zm-.544 1.376.692 1.69h-1.384z"
        clipRule="evenodd"
      />
      <path
        fill="light-dark(#323232, #ADADAD)"
        d="M63.965 29.418h1.146v4.168h2.597v1.042h-3.743zM71.302 32.574 69.3 29.418h1.34l1.243 2.091 1.265-2.09h1.302l-2.003 3.132v2.077h-1.145zM78.61 30.475h-1.586v-1.057h4.317v1.057h-1.586v4.153h-1.146v-4.153M84.503 29.418h1.146v5.21h-1.146zM88.953 32.038v-.015c0-1.481 1.117-2.694 2.716-2.694.983 0 1.57.327 2.054.803l-.729.84c-.401-.364-.81-.587-1.332-.587-.878 0-1.511.73-1.511 1.623v.014c0 .893.618 1.637 1.511 1.637.595 0 .96-.238 1.37-.61l.728.736c-.536.573-1.131.93-2.136.93-1.532.002-2.67-1.182-2.67-2.678M96.551 33.869l.678-.811c.47.387.96.632 1.555.632.469 0 .752-.186.752-.491v-.014c0-.29-.178-.44-1.049-.663-1.049-.268-1.727-.558-1.727-1.592v-.015c0-.945.76-1.57 1.823-1.57.76 0 1.406.238 1.935.662l-.595.864c-.46-.32-.915-.514-1.354-.514s-.67.201-.67.454v.014c0 .343.223.454 1.124.685 1.057.276 1.652.655 1.652 1.563v.015c0 1.034-.789 1.615-1.912 1.615a3.32 3.32 0 0 1-2.212-.835"
      />
      <path
        fill="light-dark(#090909, #EBEBEB)"
        d="m103.933 9.765 1.074 2.27h3.697v12.481h2.476V12.034h4.745v-2.27z"
      />
      <path
        fill="light-dark(#090909, #EBEBEB)"
        fillRule="evenodd"
        d="M88.279 17.146c0-4.174 3.304-7.671 7.86-7.671s7.82 3.455 7.82 7.629v.042c0 4.174-3.304 7.67-7.86 7.67s-7.82-3.453-7.82-7.628zm7.809 5.256c2.946 0 4.982-2.33 4.982-5.213v-.043c0-2.883-2.078-5.277-5.023-5.277-2.947 0-4.983 2.352-4.983 5.235v.042c0 2.882 2.079 5.256 5.024 5.256"
        clipRule="evenodd"
      />
      <path
        fill="light-dark(#090909, #EBEBEB)"
        d="M86.319 14.456v-.043c0-1.292-.376-2.377-1.16-3.182-.953-.933-2.345-1.466-4.21-1.466h-3.706l1.047 2.27h2.447c1.928 0 3.003.936 3.003 2.526v.042c0 1.504-1.117 2.59-2.982 2.59h-.629v2.266l2.843 5.057h2.873l-2.974-5.6c2.055-.593 3.448-2.024 3.448-4.46M76.106 14.456v-.043c0-1.292-.418-2.377-1.203-3.182-.953-.933-2.389-1.466-4.254-1.466h-3.705l1.047 2.27h2.447c1.928 0 3.09.936 3.09 2.526v.042c0 1.504-1.204 2.59-3.069 2.59h-.644v2.266l2.857 5.057h2.874l-2.93-5.6c2.054-.593 3.49-2.024 3.49-4.46"
      />
      <path
        fill="light-dark(#090909, #EBEBEB)"
        fillRule="evenodd"
        d="M68.504 24.516h-2.755L63.1 19.36h-6.937l-2.65 5.157H50.76l7.627-14.751h2.489zm-8.872-11.774-2.303 4.45h4.607z"
        clipRule="evenodd"
      />
      <path
        fill="light-dark(#090909, #EBEBEB)"
        d="M52.277 14.456v-.043c0-1.292-.43-2.377-1.214-3.182-.953-.933-2.685-1.466-4.55-1.466h-8.64l1.046 2.27h7.595c1.928 0 3.185.936 3.185 2.526v.042c0 .86-.541 2.59-3.185 2.59h-5.17v7.323h2.58v-5.26h2.59c1.858 0 2.86-.51 3.037-.587 1.649-.711 2.726-2.084 2.726-4.213"
      />
      <path fill={`url(#${uid}a)`} d="M14.418 36.463v.61l.305-.306z" />
      <path fill={`url(#${uid}b)`} d="m16.416 35.066-1.998-2.006v1.127l1.438 1.443z" />
      <path fill={`url(#${uid}c)`} d="m18.117 33.364-3.699-3.707v1.368l3.02 3.023z" />
      <path fill={`url(#${uid}d)`} d="m19.82 31.663-5.402-5.41v1.609l4.601 4.605z" />
      <path fill={`url(#${uid}e)`} d="m21.52 29.962-7.102-7.112V24.7l6.182 6.187z" />
      <path fill={`url(#${uid}f)`} d="m23.222 28.26-8.804-8.813v2.09l7.764 7.768z" />
      <path fill={`url(#${uid}g)`} d="M24.924 26.559 14.418 16.045v2.33l9.345 9.349z" />
      <path fill={`url(#${uid}h)`} d="M26.625 24.857 14.418 12.642v2.57l10.927 10.93z" />
      <path fill={`url(#${uid}i)`} d="M28.327 23.156 14.418 9.239v2.81L26.925 24.56z" />
      <path fill={`url(#${uid}j)`} d="M30.028 21.454 14.418 5.836v3.05l14.088 14.093z" />
      <path fill={`url(#${uid}k)`} d="M31.665 19.817 14.418 2.56v3.163l15.67 15.674z" />
      <path fill={`url(#${uid}l)`} d="M32.914 18.568 14.418.064v2.368l17.316 17.32z" />
      <path fill={`url(#${uid}m)`} d="M31.73 19.753 14.418 2.433v.128L31.67 19.817z" />
      <path fill={`url(#${uid}n)`} d="M31.73 19.753 14.418 2.433v.128L31.67 19.817z" />
      <path fill="light-dark(#323232, #ADADAD)" d="M6.218 24.763.024 18.568l6.194-6.194z" />
      <defs>
        <linearGradient
          id={`${uid}a`}
          x1={19.895}
          x2={-3.414}
          y1={17.445}
          y2={11.638}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}b`}
          x1={24.211}
          x2={0.946}
          y1={22.997}
          y2={8.93}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}c`}
          x1={26.499}
          x2={3.977}
          y1={22.328}
          y2={6.346}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}d`}
          x1={28.407}
          x2={6.268}
          y1={21.052}
          y2={4.321}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}e`}
          x1={30.203}
          x2={8.287}
          y1={19.586}
          y2={2.466}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}f`}
          x1={31.929}
          x2={10.16}
          y1={18.067}
          y2={0.705}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}g`}
          x1={33.629}
          x2={11.966}
          y1={16.512}
          y2={-1.019}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}h`}
          x1={35.325}
          x2={13.738}
          y1={14.917}
          y2={-2.731}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}i`}
          x1={36.996}
          x2={15.469}
          y1={13.325}
          y2={-4.413}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}j`}
          x1={38.673}
          x2={17.193}
          y1={11.708}
          y2={-6.1}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}k`}
          x1={40.327}
          x2={18.934}
          y1={10.166}
          y2={-7.769}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}l`}
          x1={42.018}
          x2={21.047}
          y1={8.985}
          y2={-9.523}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}m`}
          x1={41.944}
          x2={22.047}
          y1={10.215}
          y2={-9.518}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
        <linearGradient
          id={`${uid}n`}
          x1={41.953}
          x2={22.055}
          y1={10.206}
          y2={-9.527}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset={1} stopColor="#FCDE21" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default ParrotLogo;
